import type { HttpClient } from '@shared/http/http-client';
import type { IOrganizationRepository } from '@domain/data-contracts/organization-repository.interface';
import type { Organization } from '@domain/models/organization.interface';

interface OrganizationDto {
  readonly organizationId: number;
  readonly name: string;
  readonly isActive: boolean;
}

function mapDto(dto: OrganizationDto): Organization {
  return {
    id: dto.organizationId,
    name: dto.name,
    isActive: dto.isActive,
  };
}

export class OrganizationRepository implements IOrganizationRepository {
  public constructor(private readonly http: HttpClient) {}

  public async listAll(signal?: AbortSignal): Promise<readonly Organization[]> {
    const response = await this.http.get<readonly OrganizationDto[]>('/api/organizations', { signal });
    return response.data.map(mapDto);
  }
}
